import { render, staticRenderFns } from "./wrapper-modal-component.vue?vue&type=template&id=0a6f86b3&scoped=true&"
import script from "./wrapper-modal-component.vue?vue&type=script&lang=ts&"
export * from "./wrapper-modal-component.vue?vue&type=script&lang=ts&"
import style0 from "./wrapper-modal-component.vue?vue&type=style&index=0&id=0a6f86b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f86b3",
  null
  
)

export default component.exports